document.addEventListener("turbolinks:load", function (e) {
  $('div.embed_links a').text(function (index, text) {
    var count = $(this).attr("data-char-count");
    return text.length > count ? text.substring(0, count) + '...' : text;
  });
});
